// import "@/assets/icons";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { BootstrapVue3 } from "bootstrap-vue-3";
import "bootstrap-vue-3/dist/bootstrap-vue-3.css";
import "bootstrap/dist/css/bootstrap.css";
import { createPinia } from "pinia";
import piniaPersist from "pinia-plugin-persist";
import { createApp } from "vue";
import { VueReCaptcha } from "vue-recaptcha-v3";
import App from "./App.vue";
import i18n from "./i18n";
import router from "./router";

// ==== Swallow noisy unhandled rejections from 3rd-party (reCAPTCHA) ====
(function () {
  console.log('[guard] active'); // 進到這裡表示有生效
  const isNoisy = (x: any) => /timeout/i.test(String(x?.message || x || ''));
  window.addEventListener('unhandledrejection', (ev: any) => {
    if (isNoisy(ev?.reason)) ev.preventDefault?.();
  });
  window.addEventListener('error', (ev: any) => {
    const msg = String(ev?.error?.message || ev?.message || '');
    if (/timeout/i.test(msg)) ev.preventDefault?.();
  });
})();

const pinia = createPinia();
pinia.use(piniaPersist);

const app = createApp(App);
app
  .use(pinia)
  .use(router)
  .use(BootstrapVue3)
  .use(i18n)
  .use(VueReCaptcha, {
    siteKey: "6LdogwslAAAAAJKRveBFqub3_Zp7ocX9PU1508yf",
    loaderOptions: { autoHideBadge: true },
  })
  .mount("#app");
